import { Family } from "./components/family";
import { Base } from "./families.base";

export const Families = Object.assign(Base, {
    Family
});
